export default __webpack_public_path__ + "static/media/cute2.9396de2e.gif";